import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { GLOBAL_CONFIG, LanguagesEnum } from 'src/app/@core/data/globalConfig';


declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  childs?: RouteInfo[];
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  idiomaSelect: LanguagesEnum = GLOBAL_CONFIG.defaultLanguage;
  idiomas: LanguagesEnum[] = GLOBAL_CONFIG.languages;

  ROUTES: RouteInfo[] = [
    {
      path: '/home', title: 'Home', icon: 'dashboard', class: '', childs: []
    },
    {
      path: '/configuracion-pais', title: 'Configuración país', icon: 'dashboard', class: '', childs: []
    },
    {
      path: '/gestion-reglas', title: 'Gestión de reglas', icon: 'dashboard', class: '', childs: []
    }
  ];

  constructor(public translateService: TranslateService) {
    this.translateService.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.setMenu();
      });
  }

  setMenu(){
    this.translateService.get(['botones.inicio', 'botones.configuracion-pais', 'botones.gestion-reglas']).subscribe((text: any[]) => {
      this.ROUTES[0].title = text['botones.inicio'];
      this.ROUTES[1].title = text['botones.configuracion-pais'];
      this.ROUTES[2].title = text['botones.gestion-reglas'];
  });
  }

  ngOnInit() {
    this.menuItems = this.ROUTES.filter(menuItem => menuItem);
    this.idiomaSelect = this.idiomas[0];
  }

  onChangeIdioma(newValue) {
    this.idiomaSelect = newValue.value;  // don't forget to update the model here
    this.translateService.use(this.idiomaSelect);
    // ... do other stuff here ...
  }
}
